// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"SignInError__wrapper___1QoTz","button":"SignInError__button___2isL7"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Pages/SignInError.scss
// module id = hGuj
// module chunks = 0